export default "__VITE_ASSET__D1Qdryde__"